export const environment = {
  version: '1.39',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
